import { useCallback } from 'react';
import { Form } from 'react-final-form';
import { ApolloError } from '@apollo/client';
import { ValidationErrors } from 'final-form';
import { Helmet } from 'react-helmet-async';

import {
  CampaignFormProps,
  CampaignFormRenderProps,
  CampaignFormValues,
} from '@occc-app/routes/Campaign/types';
import { UpdateCampaignFormRenderComponent } from '@occc-app/routes/Campaign/CampaignUpdatePage/UpdateCampaignFormRenderComponent';

import { RequiredFieldsType } from '../../../types';

type UpdateCampaignPageProps = {
  campaignUpdate: CampaignFormProps['onSubmit'];
  required?: RequiredFieldsType<Partial<CampaignFormValues>>;
  validate?: (values: Partial<CampaignFormValues>) => Promise<ValidationErrors>;
  loading: boolean;
  campaignId: string;
  loaded: boolean;
  error?: ApolloError;
  initialValues: CampaignFormValues;
};

export const UpdateCampaignPage = ({
  initialValues,
  validate,
  campaignUpdate,
  loading,
  campaignId,
  loaded,
  error,
}: UpdateCampaignPageProps) => {
  const renderForm: CampaignFormProps['render'] = useCallback(
    ({ handleSubmit, values, valid, pristine, submitting }: CampaignFormRenderProps) => {
      return (
        <UpdateCampaignFormRenderComponent
          handleSubmit={handleSubmit}
          name={values.name}
          campaignId={campaignId}
          disabled={!valid || pristine || submitting}
          loading={loading}
          loaded={loaded}
          error={error}
        />
      );
    },
    [loading, loaded, error, campaignId],
  );

  return (
    <>
      <Helmet>
        <title>Update Campaign</title>
      </Helmet>
      <Form<CampaignFormValues>
        initialValues={initialValues}
        onSubmit={campaignUpdate}
        render={renderForm}
        validate={validate}
      />
    </>
  );
};
